export const error = {
  auth: null,
  cart: null,
  profile: null,
  createSource: null,
  createOrder: null,
  payOrder: null,
  fetchOrder: null,
  cartItems: {},
};

export const status = {
  auth: null,
  logout: null,
  cart: null,
  profile: null,
  createOrder: null,
  createSource: null,
  payOrder: null,
  fetchOrder: null,
  cartItems: {},
};

export const data = {
  user: null,
  profile: null,
  cart: null,
  order: null,
  ui: {
    showNav: false,
    showFilter: false,
    showCart: false,
    showOrderSummary: false,
    showPrices: false,
    showDetail: false,
    activeItem: null,
  },
};

export default { error, status, data };



// WEBPACK FOOTER //
// ../shop_main/store/initialState.js